import { ActionInterface } from "../../../Interface/ActionInterface";
// import Constants from "../../../Action/Constants";
// import { PersonInterface } from "../../../Entity/Entities/Person/PersonInterface";

interface StateInterface {
  byId: any;
  allIds: string[];
};

const initialState: StateInterface = {
  byId: {},
  allIds: [],
};

export const personsReducer = (state: StateInterface = initialState, action: ActionInterface): StateInterface => {
  switch (action.type) {

    default:
      return state;
  }
};
